module.exports = __webpack_public_path__ + "img/4d10226f-8e2f-47ab-8e5d-2e31b4c70493.a0ee07da.png";